import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TenantsService } from '../../core/services/tenants.service';
import { NSUserLoginComponent } from '../../Clients/NS/Components/NS-user-login/NS-user-login.component';
@Component({
  selector: 'app-user-login',
  standalone: true,
  imports: [FormsModule, CommonModule, NSUserLoginComponent],
  templateUrl: './user-login.component.html',
  styleUrl: './user-login.component.scss',
})
export class UserLoginComponent implements OnInit {
  tenantid: string = 'default';
  constructor(private TenantsService: TenantsService) { }
  ngOnInit(): void {
    this.tenantid = this.TenantsService.getTenantFromSubdomain();
    console.log('tenantid', this.tenantid);
  }
}
